import React from "react";


import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";


export const FlagIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue153'}</MuiIcon>
        );
    })
